import { buildPath, buildTemplatePath, Page, PageRoute, useParams } from "@compass/core";
import { UserManualSectionDto } from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { UserManualPageBody } from "./UserManualBody";

const routeName = "userManual";

export const userManualPageRoute: PageRoute = {
  handle: "User Manual",
  templatePath: buildTemplatePath(routeName),
  getPath: (params) => buildPath(routeName, params),
};

export const UserManualPage = () => {
  const { params } = useParams(routeName);
  const [userManualSections, setUserManualSections] = useState<UserManualSectionDto[]>();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    ApiService.userManual.getUserManualSections().then((response) => {
      setUserManualSections(response);
    });
  };

  return (
    <Page header={userManualPageRoute.handle}>
      <UserManualPageBody sections={userManualSections} />
    </Page>
  );
};
